<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div>
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <vs-button
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            @click="$router.push(`/orcamentos/novo-orcamento`).catch((err) => {})"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-success"
            >Novo</vs-button
          >
        </div>
      </div>
      <vue-good-table
        ref="my-table"
        selectionInfoClass="mytable"
        style="width: 100%"
        styleClass="vgt-table condensed"
        :search-options="{
          enabled: true,
          trigger: '',
          placeholder: 'Procurar',
          skipDiacritics: true,
        }"
        :pagination-options="paginationOptions"
        :columns="columns"
        :rows="budgets"
        @on-row-click="onRowClick"
      >
        <div slot="emptystate" class="text-center">
          Nenhum resultado encontrado
        </div>
        <template slot="table-row" slot-scope="budget">
          <span class="font-medium" v-if="budget.column.field == 'idBudget'">
            <vs-chip color="success">{{ budget.row.idBudget }}</vs-chip>
          </span>
           <span
            class="font-medium"
            v-if="budget.column.field == 'corporateName'"
            @click.stop="edit(budget.row.idBudget,budget.row.orderType )"
          >
            {{ budget.row.corporateName }}
          </span>
          <span class="font-medium" v-if="budget.column.field == 'dateOrder'">
            {{ budget.row.dateOrder }}
          </span>
          <span class="font-medium" v-if="budget.column.field == 'totalOrder'">
            {{ budget.row.totalOrder }}
          </span>
          <span class="font-medium" v-if="budget.column.field == 'orderType'">
            <div>
            <vs-chip color="success" v-if="budget.row.orderType == 'Equipamento Revenda'">
              {{ budget.row.orderType }}
            </vs-chip>
              <vs-chip color="#9ACD32" v-if="budget.row.orderType == 'Equipamento Venda Direta'">
              {{ budget.row.orderType }}
            </vs-chip>
              <vs-chip color="#1E90FF" v-if="budget.row.orderType == 'Suprimentos'">
              {{ budget.row.orderType }}
              </vs-chip>
              <vs-chip color="danger" v-if="budget.row.orderType == 'Peças'">
              {{ budget.row.orderType }}
            </vs-chip>
              <vs-chip color="warning" v-if="budget.row.orderType == 'Mão de Obra'">
              {{ budget.row.orderType }}
            </vs-chip>
              <vs-chip color="#1E90FF" v-if="budget.row.orderType == 'Mídias'">
              {{ budget.row.orderType }}
            </vs-chip>
            </div>
          </span>
          <span class="font-medium" v-if="budget.column.field == 'photo'">
            <!--{{ budget.row.userName }}-->
            <vx-tooltip :text="budget.row.userName" position="left">
              <vs-avatar
                :src="budget.row.photo"
                size="30px"
                class="border-2 border-white border-solid -m-1"
              ></vs-avatar>
            </vx-tooltip>
          </span>
          <span v-if="budget.column.field === 'action'">
            <div align="center">
              <vs-dropdown vs-custom-content vs-trigger-click>
                <a
                  class="flex items-center"
                  style="font-weight: 500; font-size: 1rem"
                  href="#"
                >
                  Mais <i class="material-icons"> expand_more </i>
                </a>
                <vs-dropdown-menu class="w-48">
                  <vs-dropdown-item @click.stop="open(budget.row.idBudget)">
                    <font-awesome-icon :icon="['fa', 'search']" class="w-4" />
                    Visualizar
                  </vs-dropdown-item>
                 <!--   <vs-dropdown-item
                    @click="
                      download(budget.row.idBudget, budget.row.corporateName)
                    "
                    ><font-awesome-icon
                      :icon="['far', 'file-pdf']"
                      class="w-4"
                    />
                    Download
                  </vs-dropdown-item>
                 <vs-dropdown-item @click="duplicate(budget.row.idBudget)"
                    ><font-awesome-icon :icon="['fas', 'copy']" class="w-4" />
                    Duplicar
                  </vs-dropdown-item>-->
                  <vs-dropdown-item
                    divider
                    @click="deleteData(budget.row.idBudget)"
                  >
                    <font-awesome-icon
                      :icon="['far', 'trash-alt']"
                      class="w-4"
                    />
                    Excluir
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </span>
        </template>
      </vue-good-table>
      <vs-popup class="Confirmar" title="Remover" :active.sync="popupActive">
        <p>Tem certeza que deseja remover esse item para lixeira?</p>
        <div class="vx-row">
          <div class="vx-col w-full mt-5">
            <vs-button
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash-2"
              @click="deleteData()"
              class="float-right"
              >Remover</vs-button
            >
          </div>
        </div>
      </vs-popup>
    </div>
    <OrderReport ref="orderReport"></OrderReport>
  </div>
  
</template>
 
<script>
import { baseApiUrl } from "@/global";
import { VueGoodTable } from "vue-good-table";
import OrderReport from "../report/orderReport";

import axios from "axios";
export default {
  components: {
    VueGoodTable,
    OrderReport
  },
  props: {
  },
  data() {
    return {
      budgets: [],
      selected: [],
      isMounted: false,
      color: null,
      action: null,
      dispatch: null,
      urlApi: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: "Próxima",
        prevLabel: "Anterior",
        rowsPerPageLabel: "Resultados por página",
        ofLabel: "de",
        pageLabel: "Página",
        allLabel: "Todos",
        mode: "pages",
        perPage: 50,
      },
      popupActive: false,
      idDelete: null,
    };
  },
  computed: {
  
  },
  methods: {
     async getBudgets() {
      this.$vs.loading();
      try {
        const response = await axios.get(
          `${baseApiUrl}/budget/getBudgets`
        );
        this.budgets = response.data;
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async showPoupUp(idBudget) {
      this.popupActive = true;
      this.idDelete = idBudget
      console.log(this.idDelete);
    },
    async open(idBudget) {
      this.$refs.orderReport.open(idBudget, 'orcamentos');
    },
    edit(idBudget, orderType) {
      if(orderType =='Equipamento Revenda' || orderType =='Equipamento Venda Direta'){
        this.$router.push(`/orcamentos/equipamentos/editar-orcamento/${idBudget}`).catch(() => {});
      }
      if(orderType =='Suprimentos' || orderType =='Mídias'){
        this.$router.push(`/orcamentos/suprimentos/editar-orcamento/${idBudget}`).catch(() => {});
      }
    },
    async duplicate(idBudget) {
      this.$vs.loading();
      console.log(this.urlApi)
      try {
        await axios.post(
          `${baseApiUrl}/${this.urlApi}/duplicate`,
          { idBudget }
        );
      } catch (error) {
        console.log(error.response.data);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema ao duplicar",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
      let payload = {
        loading: this.$vs.loading,
        type: "notCompleted",
        userGroup: this.$store.state.user.userGroup,
      };
      await this.$store.dispatch(this.dispatch, payload);
    },
    async deleteData(idBudget) {
      this.$vs.loading();
      let response
      try {
        if (idBudget) {
          response = await axios.post(`${baseApiUrl}/budget/delete`, {idBudget});
          this.$vs.notify({
            title: "Deletado",
            text: "com Sucesso",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        }
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
        await this.getBudgets();
      }
    },
    async download(idBudget, corporateName) {
      this.$refs.budgetReport.download(idBudget, this.path, corporateName);
    },
    openStage(idBudget) {
      this.$router.push(`/etapa-${this.path}/${idBudget}`).catch(() => {});
    },
    onRowClick(params) {
      console.log(params)
      // Somente para ter a mão do mouse clique
    },
    mountTable() {
      this.columns = [
        {
          label: "Código",
          field: "idBudget",
          tdClass: "align-middle",
        },
        {
          label: "Cliente",
          field: "corporateName",
          tdClass: "align-middle",
        },
        {
          label: "Data",
          field: "dateOrder",
          type: "date",
          dateInputFormat: "dd/MM/yyyy",
          dateOutputFormat: "dd/MM/yyyy",
          tdClass: "align-middle",
        },
        {
          label: "Valor",
          field: "totalOrder",
          tdClass: "align-middle",
        },
        {
          label: "Tipo",
          field: "orderType",
          tdClass: "align-middle",
        },
        {
          label: "Consultor",
          field: "photo",
          tdClass: "align-middle",
        },
        {
          label: "Ações",
          field: "action",
          tdClass: "align-middle",
        },
      ];
    },
  },
  async created() {
    await this.getBudgets();
    this.mountTable();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>